require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tapd-in-the-ultimate-guide-to-pinterest-buyable-pins-for-ecommerce.json") })
        }
      }, "path---tapd-in-the-ultimate-guide-to-pinterest-buyable-pins-for-ecommerce");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tapd-in-the-ultimate-guide-to-pinterest-buyable-pins-for-ecommerce!./.cache/json/tapd-in-the-ultimate-guide-to-pinterest-buyable-pins-for-ecommerce.json
// module id = 872
// module chunks = 231608221292675